export default __webpack_public_path__ + "static/media/medium.7141940a.svg";